// Mock data for Instagram-style feed
// This will be replaced with real data in future phases

export const mockStories = [
  {
    id: 'story-1',
    puzzleId: 'puzzle-abc123',
    username: 'puzzle_master',
    avatarUrl: null,
    hasNewStory: true,
  },
  {
    id: 'story-2',
    puzzleId: 'puzzle-def456',
    username: 'jigsaw_jane',
    avatarUrl: null,
    hasNewStory: true,
  },
  {
    id: 'story-3',
    puzzleId: 'puzzle-ghi789',
    username: 'piece_by_piece',
    avatarUrl: null,
    hasNewStory: true,
  },
  {
    id: 'story-4',
    puzzleId: 'puzzle-jkl012',
    username: 'daily_puzzler',
    avatarUrl: null,
    hasNewStory: false,
  },
  {
    id: 'story-5',
    puzzleId: 'puzzle-mno345',
    username: 'puzzle_addict',
    avatarUrl: null,
    hasNewStory: false,
  },
];

export const mockPosts = [
  {
    id: 'post-1',
    puzzleId: 'puzzle-abc123',
    user: {
      id: 'user-1',
      username: 'puzzle_master',
      avatarUrl: null,
    },
    imageUrl: 'https://picsum.photos/seed/puzzle1/470/470',
    caption: 'Just completed this beautiful landscape puzzle! Took me 45 minutes but totally worth it. Who else loves nature puzzles?',
    likeCount: 142,
    commentCount: 12,
    timestamp: '2h',
    isLiked: false,
    isBookmarked: false,
    gridSize: '5x5',
  },
  {
    id: 'post-2',
    puzzleId: 'puzzle-def456',
    user: {
      id: 'user-2',
      username: 'jigsaw_jane',
      avatarUrl: null,
    },
    imageUrl: 'https://picsum.photos/seed/puzzle2/470/470',
    caption: 'Morning puzzle session with my coffee. This one was tricky!',
    likeCount: 89,
    commentCount: 5,
    timestamp: '5h',
    isLiked: true,
    isBookmarked: false,
    gridSize: '4x4',
  },
  {
    id: 'post-3',
    puzzleId: 'puzzle-ghi789',
    user: {
      id: 'user-3',
      username: 'piece_by_piece',
      avatarUrl: null,
    },
    imageUrl: 'https://picsum.photos/seed/puzzle3/470/470',
    caption: 'New personal best! Finished in under 10 minutes. Practice makes perfect!',
    likeCount: 256,
    commentCount: 23,
    timestamp: '1d',
    isLiked: false,
    isBookmarked: true,
    gridSize: '3x3',
  },
  {
    id: 'post-4',
    puzzleId: 'puzzle-jkl012',
    user: {
      id: 'user-4',
      username: 'daily_puzzler',
      avatarUrl: null,
    },
    imageUrl: 'https://picsum.photos/seed/puzzle4/470/470',
    caption: 'Day 100 of my puzzle streak! This hobby has been so relaxing.',
    likeCount: 512,
    commentCount: 45,
    timestamp: '2d',
    isLiked: false,
    isBookmarked: false,
    gridSize: '6x6',
  },
];

export const mockSuggestedUsers = [
  {
    id: 'suggested-1',
    username: 'puzzle_pro',
    avatarUrl: null,
    relation: 'Followed by puzzle_master',
  },
  {
    id: 'suggested-2',
    username: 'jigsaw_king',
    avatarUrl: null,
    relation: 'Suggested for you',
  },
  {
    id: 'suggested-3',
    username: 'piece_perfect',
    avatarUrl: null,
    relation: 'Followed by jigsaw_jane + 3 more',
  },
  {
    id: 'suggested-4',
    username: 'puzzle_newbie',
    avatarUrl: null,
    relation: 'New to Picture Puzzle',
  },
];

// Profile page data
export const mockProfileData = {
  username: 'demo_user',
  displayName: 'Demo User',
  bio: 'Puzzle enthusiast | Solving one piece at a time',
  avatarUrl: null,
  stats: {
    posts: 12,
    followers: 204,
    following: 529,
  },
};

// Mock puzzles for profile grid
export const mockUserPuzzles = [
  {
    id: 'puzzle-1',
    imageUrl: 'https://picsum.photos/seed/userpuzzle1/300/300',
    likeCount: 42,
    commentCount: 5,
  },
  {
    id: 'puzzle-2',
    imageUrl: 'https://picsum.photos/seed/userpuzzle2/300/300',
    likeCount: 89,
    commentCount: 12,
  },
  {
    id: 'puzzle-3',
    imageUrl: 'https://picsum.photos/seed/userpuzzle3/300/300',
    likeCount: 156,
    commentCount: 23,
  },
  {
    id: 'puzzle-4',
    imageUrl: 'https://picsum.photos/seed/userpuzzle4/300/300',
    likeCount: 67,
    commentCount: 8,
  },
  {
    id: 'puzzle-5',
    imageUrl: 'https://picsum.photos/seed/userpuzzle5/300/300',
    likeCount: 234,
    commentCount: 31,
  },
  {
    id: 'puzzle-6',
    imageUrl: 'https://picsum.photos/seed/userpuzzle6/300/300',
    likeCount: 45,
    commentCount: 3,
  },
  {
    id: 'puzzle-7',
    imageUrl: 'https://picsum.photos/seed/userpuzzle7/300/300',
    likeCount: 112,
    commentCount: 15,
  },
  {
    id: 'puzzle-8',
    imageUrl: 'https://picsum.photos/seed/userpuzzle8/300/300',
    likeCount: 78,
    commentCount: 9,
  },
  {
    id: 'puzzle-9',
    imageUrl: 'https://picsum.photos/seed/userpuzzle9/300/300',
    likeCount: 189,
    commentCount: 27,
  },
];

export default {
  mockStories,
  mockPosts,
  mockSuggestedUsers,
  mockProfileData,
  mockUserPuzzles,
};
